import type {
    AddDonationRequestBody,
    AddItemRequestBody,
    CartUI,
    CartCreateBody,
    RemoveItemRequestBody,
    UpdateItemQtyRequestBody,
    PickupInfoRequestBody,
    AddBillingAddressRequestBody,
    ApplyPromoCodeRequestBody,
    AddPaymentMethodRequestBody,
    PlaceOrderRequestBody,
    UpdateItemFulfillmentMethodRequestBody,
    TreatPointRequestBody,
    SetShippingMethodRequestBody,
    AddPrescriptionBody,
    DeliveryOptionsPost,
} from '@libs/common-node';
import { AUTH_COOKIES, AUTH_HEADERS, COOKIES, apiFetch, type HttpMethod } from '@libs/core';
import Cookie from 'js-cookie';
import { extractCustomerKeyFromAccessToken } from './extractCustomerKeyFromAccessToken';

export const getHeaders = () => {
    const headers: HeadersInit = {};
    // get header values
    const token = Cookie.get(AUTH_COOKIES.ACCESS_TOKEN);
    const anonymousKey = Cookie.get(AUTH_COOKIES.PETM_ANONYMOUS_KEY);
    const customerKey = Cookie.get(AUTH_COOKIES.PETM_CUSTOMER_KEY);
    const cartId = Cookie.get(COOKIES.CART_ID);
    const deviceType = Cookie.get(COOKIES.X_PETM_CHANNEL);
    const visitorId = Cookie.get(COOKIES.X_PETM_VISITOR_ID);

    if (token) {
        headers[AUTH_HEADERS.AUTHORIZATION] = `Bearer ${token}`;

        const customerKey = extractCustomerKeyFromAccessToken(token);

        if (customerKey) {
            headers[AUTH_HEADERS.X_PETM_CUSTOMER_KEY] = customerKey;
        }
    }

    if (cartId) {
        headers[AUTH_HEADERS.X_PETM_CART_ID] = cartId;
    }

    // this is a check if there are both cookies (customerKey > anonymousKey)
    if (anonymousKey && !customerKey) {
        headers[AUTH_HEADERS.X_PETM_ANONYMOUS_KEY] = anonymousKey;
    }

    if (customerKey) {
        headers[AUTH_HEADERS.X_PETM_CUSTOMER_KEY] = customerKey;
    }

    if (deviceType) {
        headers[AUTH_HEADERS.X_PETM_CHANNEL] = deviceType;
    }

    if (visitorId) {
        headers[AUTH_HEADERS.X_PETM_VISITOR_ID] = visitorId;
    }

    return headers;
};

const fetchCart = async <T = CartUI | null>(
    url: string,
    method: HttpMethod,
    body?:
        | CartCreateBody
        | AddItemRequestBody
        | UpdateItemQtyRequestBody
        | UpdateItemFulfillmentMethodRequestBody
        | RemoveItemRequestBody
        | AddDonationRequestBody
        | PickupInfoRequestBody
        | AddBillingAddressRequestBody
        | ApplyPromoCodeRequestBody
        | AddPaymentMethodRequestBody
        | PlaceOrderRequestBody
        | SetShippingMethodRequestBody
        | TreatPointRequestBody
        | AddPrescriptionBody
        | DeliveryOptionsPost,
    additionalHeaders?: { [key: string]: string },
    additionalSuccessCodes: number[] = [303, 400],
    requestInit?: RequestInit
): Promise<T | null> =>
    apiFetch<T | null>(url, {
        ...requestInit,
        method,
        body: body ? JSON.stringify(body) : undefined,
        headers: {
            ...getHeaders(),
            ...additionalHeaders,
        },
        additionalSuccessCodes,
    }) as Promise<T | null>;

export default fetchCart;
